import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-2f2744fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-footer-main" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 page-footer" }
const _hoisted_5 = { class: "footer-text" }
const _hoisted_6 = { class: "footer-text-wrap" }
const _hoisted_7 = { class: "links" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "gap" }, null, -1))
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "copyright" }
const _hoisted_12 = { class: "footer-logo" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    class: "link-1",
                    target: "blank",
                    href: _ctx.termsUrl
                  }, "Terms of Use", 8, _hoisted_8)
                ]),
                _hoisted_9,
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    class: "link-2",
                    target: "blank",
                    href: _ctx.privacyUrl
                  }, "Privacy Policy", 8, _hoisted_10)
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("small", null, "© Copyright " + _toDisplayString(_ctx.copyrightYearRange) + " - The Law Society of New South Wales (ABN 98 696 304 966, ACN 000 000 699)", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              class: "logo",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.logoClick())),
              src: _imports_0,
              alt: "Footer logo",
              title: "The Law Society of New South Wales"
            })
          ])
        ])
      ])
    ])
  ]))
}